import moment from 'moment';
import { formatIsoDate, formatIsoDateTime } from 'utils/dates';
import Base from 'app/models/base';

export const DATERANGE_PARAM_TYPES = {
  DATETIME: 0,
  DATE: 1,
};

export default Base.extend({
  /* paramKeys should be used with the keys `startKey`/`endKey` */
  initialize({ startDatetime, endDatetime, paramType, paramKeys = {} }) {
    this.set('startDatetime', startDatetime || moment.utc().subtract(1, 'months').add(1, 'days').startOf('day'));
    this.set('endDatetime', endDatetime || moment.utc().startOf('day'));
    this.paramType = paramType;
    this.paramKeys = paramKeys;
  },

  getStartDatetimeForParam() {
    return moment(this.get('startDatetime')).utc().startOf('day');
  },

  getEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().endOf('day');
  },

  getDayAfterEndDatetimeForParam() {
    return moment(this.get('endDatetime')).utc().add(1, 'days').endOf('day');
  },

  getParams() {
    const startKey = this.paramKeys.startKey;
    const endKey = this.paramKeys.endKey;

    switch (this.paramType) {
      case DATERANGE_PARAM_TYPES.DATETIME:
        return {
          [ startKey || 'start_datetime' ]: formatIsoDateTime(this.getStartDatetimeForParam()),
          [ endKey || 'end_datetime' ]: formatIsoDateTime(this.getEndDatetimeForParam()),
        };
      case DATERANGE_PARAM_TYPES.DATE:
        return {
          [ startKey || 'start_date' ]: formatIsoDate(this.getStartDatetimeForParam()),
          [ endKey || 'end_date' ]: formatIsoDate(this.getEndDatetimeForParam()),
        };
      default:
        throw new Error('To use the getParams method, DateRange must have been initialized with a paramType ');
    }
  },

  daysBetweenDates() {
    return Math.ceil(this.get('endDatetime').utc().diff(this.get('startDatetime').utc(), 'days', true));
  }
});



// WEBPACK FOOTER //
// ./app/models/date_range.js